@if (component(); as component) {
<section *ngIf="matches().length > 0" class="schedule">
  <div class="schedule__header">
    <div class="schedule__title">{{ 'schedule.schedule' | translate }}</div>
  </div>

  <tisa-carousel
    #carousel
    class="schedule__list"
    (scrolledToEnd)="onButtonRightStatusChanges($event)"
    (scrolledToBeginning)="onButtonLeftStatusChanges($event)"
  >
    @for ( match of matches(); track match.id) {
    <tisa-match-tile [match]="match" class="schedule__tile"></tisa-match-tile>
    }
  </tisa-carousel>

  <div class="schedule__footer">
    <a class="schedule__schedule-button" [routerLink]="['/', locale(), 'timetable']">
      <span>{{ 'schedule.seeWholeSchedule' | translate }}</span>
      <app-icon name="chevron-right"></app-icon>
    </a>

    <div class="schedule__arrows-container">
      <button
        class="schedule__arrow schedule__arrow--left"
        (click)="carousel.scrollLeft()"
        [disabled]="buttonLeftDisabled()"
      >
        <app-icon name="arrow-left"></app-icon>
      </button>
      <button
        class="schedule__arrow schedule__arrow--right"
        (click)="carousel.scrollRight()"
        [disabled]="buttonRightDisabled()"
      >
        <app-icon name="arrow-right"></app-icon>
      </button>
    </div>
  </div>
</section>
}
